import { Experience, Skill, Education, ContactInfo, SocialLink, Stat, NavItem } from '../types';

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const navItems: NavItem[] = [
  { id: '1', label: 'Home', href: '#home' },
  { id: '2', label: 'About me', href: '#about' },
  { id: '3', label: 'Services', href: '#services' },
  { id: '4', label: 'Contact me', href: '#contact' },
];

export const socialLinks: SocialLink[] = [
  { id: '1', name: 'LinkedIn', icon: 'linkedin', url: 'https://www.linkedin.com/in/shristi-subedi-8814b7266/' },
  { id: '2', name: 'Email', icon: 'mail', url: 'mailto:shristisubedi.afmc@gmail.com' },
  { id: '3', name: 'Website', icon: 'globe', url: '#' },
];

export const stats: Stat[] = [
  { id: '1', number: '5+', label: 'Experiences' },
  { id: '2', number: '20+', label: 'Project done' },
  { id: '3', number: '80+', label: 'Happy Clients' },
];

export const services: Service[] = [
  {
    id: '1',
    title: 'Vouching',
    description: 'Comprehensive vouching services for financial transactions, ensuring accuracy and compliance with accounting standards.',
    icon: 'check-square'
  },
  {
    id: '2',
    title: 'Financial Reports Generation',
    description: 'Professional financial reporting including balance sheets, income statements, and cash flow statements with detailed analysis.',
    icon: 'file-text'
  },
  {
    id: '3',
    title: 'UK Tax Regulations',
    description: 'Expert knowledge of UK tax laws, compliance requirements, and regulatory frameworks for businesses and individuals.',
    icon: 'gavel'
  },
  {
    id: '4',
    title: 'Tax Savings Strategies',
    description: 'Strategic tax planning and optimization to maximize savings while ensuring full compliance with tax regulations.',
    icon: 'trending-up'
  },
  {
    id: '5',
    title: 'Cooperative Structure Understanding',
    description: 'Deep understanding of cooperative business models, governance structures, and regulatory compliance requirements.',
    icon: 'users'
  },
  {
    id: '6',
    title: 'Logistics Understanding',
    description: 'Comprehensive knowledge of supply chain management, logistics operations, and cost optimization strategies.',
    icon: 'truck'
  },
  {
    id: '7',
    title: 'NGO Act Knowledge',
    description: 'Expert understanding of NGO regulations, compliance requirements, and best practices for non-profit organizations.',
    icon: 'heart'
  }
];

export const experiences: Experience[] = [
  {
    id: '1',
    title: 'Audit Associate',
    company: 'Pradhan and Shakya Associates',
    duration: 'August 2025 – Present',
    description: [
      'Performing comprehensive audits for NGOs and cooperatives',
      'Ensuring compliance with regulatory requirements and accounting standards',
      'Conducting detailed financial analysis and risk assessments',
      'Preparing audit reports and recommendations for improvement',
    ],
  },
  {
    id: '2',
    title: 'Internal Audit Intern',
    company: 'Nepal Rastra Bank (NRB)',
    duration: 'Nov 2023 – Mar 2024',
    description: [
      'Assisted in verifying financial transactions and documentation for internal audits',
      'Supported compliance assessments with internal policies and regulatory standards',
      'Helped in drafting summary audit reports and maintained accurate working papers',
      'Observed central banking procedures and control systems',
    ],
  },
];

export const skills: Skill[] = [
  { id: '1', name: 'Basic Internal Audit Procedures', category: 'technical' },
  { id: '2', name: 'Microsoft Excel', category: 'technical' },
  { id: '3', name: 'Microsoft Word', category: 'technical' },
  { id: '4', name: 'Microsoft PowerPoint', category: 'technical' },
  { id: '5', name: 'Analytical thinking', category: 'soft' },
  { id: '6', name: 'Problem-Solving Skills', category: 'soft' },
  { id: '7', name: 'Team work and adaptability', category: 'soft' },
  { id: '8', name: 'Attention to Detail', category: 'soft' },
  { id: '9', name: 'Time Management', category: 'soft' },
];

export const education: Education[] = [
  {
    id: '1',
    degree: 'ACCA Applied Skill',
    duration: '2024 - present',
    description: 'Passed (FR and TAX), FM in June 2025',
  },
  {
    id: '2',
    degree: 'BBS 4th year',
    duration: '2021-2025',
    description: 'Nepal Commerce Campus, TU | Result waiting',
  },
  {
    id: '3',
    degree: 'CAP 1, ICAN',
    duration: '2021',
    description: '61.33%',
  },
  {
    id: '4',
    degree: 'Class 12th NEB',
    duration: '2020',
    description: 'GPA-3.62',
  },
  {
    id: '5',
    degree: 'Class 10th NEB',
    duration: '2018',
    description: 'GPA-3.80',
  },
];

export const contactInfo: ContactInfo[] = [
  {
    id: '1',
    type: 'email',
    icon: 'mail',
    value: 'shristisubedi.afmc@gmail.com',
  },
  {
    id: '2',
    type: 'phone',
    icon: 'phone',
    value: '9866157503',
  },
];

export const personalInfo = {
  name: 'Shristi Subedi',
  title: 'ACCA Skill Student',
  greeting: 'Hi I am',
  about: "I'm a detail-oriented and motivated ACCA Skill student with a strong foundation in UK Taxation and management accounting, Finance and Auditing. I have a passion for financial analysis, tax planning, and ensuring regulatory compliance. I enjoy working with numbers, analyzing financial data, and helping businesses optimize their financial processes. My expertise includes preparing detailed financial reports, conducting thorough audits, and providing strategic tax advice. I thrive in environments where I can apply my analytical skills to solve complex financial challenges and contribute to organizational growth through sound financial management.",
};
